declare namespace $ {

	type $mol_view__sub_shm_hitalama_vk_posts_table_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_posts_table_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_posts_table_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_posts_table_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_posts_table_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_posts_table_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_posts_table_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_table['post_id'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_posts_table_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_table['post_date'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_posts_table_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_table['post_likes'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_posts_table_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_table['post_reposts'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_posts_table_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_table['post_comments'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_posts_table_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_table['post_views'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_hitalama_vk_posts_table_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_table__head_shm_hitalama_vk_posts_table_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_table['head'] >
	>
	type $shm_hitalama_table__rows_shm_hitalama_vk_posts_table_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_posts_table['posts_rows'] >
		,
		ReturnType< $shm_hitalama_table['rows'] >
	>
	export class $shm_hitalama_vk_posts_table extends $shm_hitalama_vk_posts_multi {
		Head_id( ): $mol_view
		Head_date( ): $mol_view
		Head_likes( ): $mol_view
		Head_reposts( ): $mol_view
		Head_comments( ): $mol_view
		Head_views( ): $mol_view
		Post_id( id: any): $mol_paragraph
		Post_date( id: any): $mol_paragraph
		Post_likes( id: any): $mol_paragraph
		Post_reposts( id: any): $mol_paragraph
		Post_comments( id: any): $mol_paragraph
		Post_views( id: any): $mol_paragraph
		Post_row( id: any): $mol_view
		posts_rows( ): readonly(any)[]
		Table( ): $shm_hitalama_table
		Sub( ): ReturnType< $shm_hitalama_vk_posts_table['Table'] >
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map